import { Component, OnInit, Input } from '@angular/core';
import { FactoryService } from '@services/common/factory.service';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from '@comps/components.module';
import { ErrInfo } from '@models/com-err-model';
import { AcpService } from '@services/common/acp.service';
import { ComSubService } from '@services/common/com-sub.service';

@Component({
  standalone: true,
  imports:[CommonModule,ComponentsModule],
  selector: 'not-found',
  templateUrl: './not-found.component.html'
})
export class NotFoundComponent implements OnInit {
  public showErr: boolean = false;
  public errList: ErrInfo[];
  public defaultImg: string;
  public btnTxt: string;
  public mobileStye: boolean = false;

  constructor(
    private acpSer: AcpService,
    private comSubSer: ComSubService,
    public factorySer: FactoryService
  ) {
    this.factorySer.errCode = '404-not found';
  }

  async ngOnInit() {
    this.comSubSer.refreshLoading(true);
    const lang = this.factorySer.getLanguage();
    this.errList = this.factorySer.errList || this.factorySer.getSessionInfo(`errList.${lang}`, true);
    if (this.errList) {
      this.comSubSer.refreshLoading(false);
      this.showErr = true;
    } else { 
      const resp = await this.acpSer.fetchAcp(['errorPage']);
      if (resp?.code === '0' && resp?.data) {
        const data = resp.data;
        sessionStorage.setItem(`errList.${lang}`, JSON.stringify(data));
        this.factorySer.errList = data;
        this.showErr = true;
      } else {
        console.log('not-found fetchAcp no data...'), resp;
      }
    }
  }

}
